import { Check, Circle } from "lucide-react";

interface PasswordRequirementsProps {
  password: string;
}

const requirements = [
  { label: "No mínimo 10 caracteres", test: (value: string) => value.length >= 10 },
  { label: "Uma letra maiúscula", test: (value: string) => /[A-Z]/.test(value) },
  { label: "Uma letra minúscula", test: (value: string) => /[a-z]/.test(value) },
  { label: "Um número", test: (value: string) => /[0-9]/.test(value) },
  { label: "Um caractere especial", test: (value: string) => /[^A-Za-z0-9]/.test(value) },
];

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  return (
    <div className="password-requirements" aria-label="Requisitos da senha">
      {requirements.map((requirement) => {
        const valid = requirement.test(password);
        return (
          <div className={valid ? "requirement requirement--valid" : "requirement"} key={requirement.label}>
            {valid ? <Check aria-hidden="true" /> : <Circle aria-hidden="true" />}
            <span>{requirement.label}</span>
          </div>
        );
      })}
    </div>
  );
}
